import React, {Component} from 'react';
import {BrowserRouter as Router } from 'react-router-dom'
import '../styles/App.css';
import '../styles/Navigation.scss'
import '../styles/AboutMe.scss'
import '../styles/Projects.scss'
import '../styles/Skills.scss'
import '../styles/Contact.scss'
import '../styles/ErrorPage.scss'

import Navigation from './Navigation'
import Page from './Page'

class App extends Component {

  render() { 
    
    return (
      <Router>
        <div className="app">
          <nav>
            {<Navigation/>}
          </nav>
          <main>
              {<Page/>}
          </main>
        </div>
      </Router>
    );
  }
}

export default App;
